<template>
  <div class="part-item projectBuilding">
    <p class="part-title">附件材料清单
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('materialsFile')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openMaterialsfile"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">1. 课程团队成员和课程内容政治审查意见（必须提供）：</span>
      <div class="content-text">
        <p
          class="fangsong"
          style="margin-bottom: 10px;color:#909090"
        >（申报课程高校党委负责对本校课程团队成员以及申报课程的内容进行政审，出具政审意见并加盖党委印章；团队成员涉及多校时，各校党委分别对本校人员出具意见；非高校成员由其所在单位党组织出具意见。团队成员政审意见内容包括政治表现、是否存在违法违纪记录、师德师风、学术不端、五年内是否出现过重大教学事故等问题；课程内容审查包括价值取向是否正确，对于我国政治制度以及党的理论、路线、方针、政策等理解和表述是否准确无误，对于国家主权、领土表述及标注是否准确，等等。）</p>
        <template v-if="formInfo.materials_file && formInfo.materials_file.politicalArry">
          <p
            v-for="(file,key) in formInfo.materials_file.politicalArry"
            :key="key"
          >
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
              style="color: #337ab7;"
            >{{file.name}}</a>
          </p>
        </template>
        <span
          v-else
          class="content-title"
        >暂无内容</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">2. 课程内容学术性评价意见（必须提供）：</span>
      <div class="content-text">
        <p
          class="fangsong"
          style="margin-bottom: 10px;color:#909090"
        >（由学校学术性组织（校教指委或学术委员会等），或相关部门组织的相应学科专业领域专家（不少于3名）组成的学术审查小组，经一定程序评价后出具。须由学术性组织盖章或学术审查小组全部专家签字。无统一格式要求。）</p>
        <template v-if="formInfo.materials_file && formInfo.materials_file.learnArry">
          <p
            v-for="(file,key) in formInfo.materials_file.learnArry"
            :key="key"
          >
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
              style="color: #337ab7;"
            >{{file.name}}</a>
          </p>
        </template>
        <span
          v-else
          class="content-title"
        >暂无内容</span>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">3. 校外评价意见（可选提供）：</span>
      <div class="content-text">
        <p
          class="fangsong"
          style="margin-bottom: 10px;color:#909090"
        >（评价意见作为课程有关学术水平、课程质量、应用效果等某一方面的佐证性材料或补充材料，可由课程应用高校或社会应用机构等出具。评价意见须经相关单位盖章，以1份为宜，不得超过２份。无统一格式要求。）</p>
        <template v-if="formInfo.materials_file && formInfo.materials_file.outsideArry">
          <p
            v-for="(file,key) in formInfo.materials_file.outsideArry"
            :key="key"
          >
            <a
              target="_blank"
              :href="file?file.path:'javascript:;'"
              :download="file?file.name:''"
              style="color: #337ab7;"
            >{{file.name}}</a>
          </p>
        </template>
        <span
          v-else
          class="content-title"
        >暂无内容</span>
      </div>
    </div>

    <div
      class="form_overlay"
      id="building_overlay"
      :style="formatShowWindow(showWindow.materialsfile)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style="width:700px"
      >
        <div class="form_title">附件材料</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.materialsfile = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div class="form_content">
          <form id="buildingForm">
            <div class="item">
              <span
                class="label"
                style="width: 350px;"
              ><i class="require"></i>课程团队成员和课程内容政治审查意见（必须提供）</span>
              <div style="float:left">
                <div class="teachEdit">
                  <div
                    class="file"
                    v-for="(item,index) in formMaterialsFile.politicalArry"
                    :key="index"
                  >
                    <a>{{item.name}}</a>
                    <span
                      class="del"
                      @click="delMaterials(1, index)"
                    >x</span>
                  </div>
                  <span
                    class="upload"
                    @click="MaterialsFileType = 1,showFileWindow()"
                    style=""
                  >上传</span>
                </div>
              </div>
            </div>
            <div class="item">
              <span
                class="label"
                style="width: 350px;"
              ><i class="require"></i>课程内容学术性评价意见（必须提供）</span>
              <div style="float:left">
                <div class="teachEdit">
                  <div
                    class="file"
                    v-for="(item,index) in formMaterialsFile.learnArry"
                    :key="index"
                  >
                    <a>{{item.name}}</a>
                    <span
                      class="del"
                      @click="delMaterials(2, index)"
                    >x</span>
                  </div>
                  <span
                    class="upload"
                    @click="MaterialsFileType = 2,showFileWindow()"
                    style=""
                  >上传</span>
                </div>
              </div>
            </div>
            <div class="item">
              <span
                class="label"
                style="width: 350px;"
              ><i class="require"></i>校外评价意见</span>
              <div style="float:left">
                <div class="teachEdit">
                  <div
                    class="file"
                    v-for="(item,index) in formMaterialsFile.outsideArry"
                    :key="index"
                  >
                    <a>{{item.name}}</a>
                    <span
                      class="del"
                      @click="delMaterials(3, index)"
                    >x</span>
                  </div>
                  <span
                    class="upload"
                    @click="MaterialsFileType = 3,showFileWindow()"
                    style=""
                  >上传</span>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.materialsfile = false"
            class="button close"
            id="building_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveMaterialsfile(1)"
            class="button"
            id="building_submit"
          >提交</a>
        </div>
      </div>
    </div>

    <div
      id="file-upload-overlay"
      :style="showWindow.bigFile ? 'display: block' : ''"
    >
      <div class="file-upload-bg"></div>
      <div class="file-upload">
        <div
          class="file-upload-type"
          v-show="showWindow.courseware"
        >允许上传的文件扩展名：jpg, png, mp4</div>
        <div
          class="file-upload-type"
          v-show="showWindow.video"
        >允许上传的文件扩展名：mp4</div>
        <div
          class="file-upload-type"
          v-show="showWindow.guide"
        >允许上传的文件扩展名：mp4</div>
        <div
          class="file-upload-type"
          v-show="showWindow.teach"
        >允许上传的文件扩展名：mp4,doc,jpg,png,pdf</div>
        <div
          class="file-upload-type"
          v-show="showWindow.promise"
        >允许上传的文件扩展名：jpg, png</div>
        <div
          class="file-upload-type"
          v-show="showWindow.materialsfile"
        >允许上传的文件扩展名：mp4,doc,jpg,png,pdf</div>
        <div
          class="file-upload-close"
          @click="hideFileWindow"
        >×</div>
        <span
          class="file_uploadBtn"
          id="file_uploadBtn"
          style="display: block;"
        >
          选择文件<input
            type="file"
            id="file_fileInput"
            ref="docFile"
            accept=".mp4,.doc,.jpg,.png,.pdf"
            style="display: block;"
            @change="fileChange"
          >
        </span>
        <div
          class="fileBox"
          id="file_uploadBox"
          style="display: block;"
        >
          <span
            class="pauseBtn"
            id="file_pauseBtn"
            style="display: none;"
          >暂停</span>
          <span
            class="goBtn"
            id="file_goBtn"
            style="display:none;"
          >继续</span>
          <div
            class="filename"
            id="file_filename"
            style="display: none;"
          ></div>
          <div
            class="pbar"
            :style="showWindow.bigFileOption.showProgress ? 'display: block' : 'display: none'"
          >
            <div
              class="progress"
              id="file_progress"
              :style="'width: ' + Math.ceil(showWindow.bigFileOption.progressValue * 4.2) + 'px;'"
            ></div>
            <div id="file_percent">{{ showWindow.bigFileOption.progressValue }}%</div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExperimentMaintainMaterial',
  props: ['isShow', 'expId'],
  data() {
    return {
      formInfo: {
        materials_file: {
          politicalArry: [],
          learnArry: [],
          outsideArry: []
        }
      },
      showWindow: {
        materialsfile: false,
        bigFile: false,
        bigFileOption: {
          showProgress: false,
          progressValue: 0
        }
      },
      formMaterialsFile: {
        politicalArry: [],
        learnArry: [],
        outsideArry: []
      }
    }
  },
  methods: {
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    delMaterials(type, i) {
      if (type === 1) {
        this.formMaterialsFile.politicalArry.splice(i, 1)
      } else if (type === 2) {
        this.formMaterialsFile.learnArry.splice(i, 1)
      } else if (type === 3) {
        this.formMaterialsFile.outsideArry.splice(i, 1)
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.materials_file = data.materials_file ? JSON.parse(data.materials_file) : {
          politicalArry: [],
          learnArry: [],
          outsideArry: []
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    openMaterialsfile() {
      if (this.formInfo.materials_file) {
        this.formMaterialsFile = JSON.parse(JSON.stringify(this.formInfo.materials_file))
        if (!this.formMaterialsFile.politicalArry) {
          this.formMaterialsFile.politicalArry = []
        }
        if (!this.formMaterialsFile.learnArry) {
          this.formMaterialsFile.learnArry = []
        }
        if (!this.formMaterialsFile.outsideArry) {
          this.formMaterialsFile.outsideArry = []
        }
      } else {
        this.formMaterialsFile = {
          politicalArry: [],
          learnArry: [],
          outsideArry: []
        }
      }
      this.showWindow.materialsfile = true
    },
    async saveMaterialsfile(type) {
      if (type) {
        if (!this.formMaterialsFile.politicalArry.length) {
          this.$layer.msg('课程团队成员和课程内容政治审查意见至少上传一个文件！')
          return
        }
        if (!this.formMaterialsFile.learnArry.length) {
          this.$layer.msg('课程内容学术性评价意见至少上传一个文件！')
          return
        }
      } else {
        this.formInfo.materials_file = {
          politicalArry: [],
          learnArry: [],
          outsideArry: []
        }
      }
      const url = '/experiment/' + this.expId + '/'
      await this.$http.put(url, {
        materials_file: type ? JSON.stringify(this.formMaterialsFile) : ''
      }).then((data) => {
        if (data.id) {
          if (type) {
            this.formInfo.materials_file = JSON.parse(data.materials_file)
          } else {
            this.formInfo.materials_file = {
              politicalArry: [],
              learnArry: [],
              outsideArry: []
            }
          }
          this.showWindow.materialsfile = false
        } else {
          this.$layer.msg('修改失败！')
        }
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('修改失败！')
      })
    },
    showFileWindow() {
      if (this.isShow) {
        this.showWindow.bigFile = true
      }
    },
    hideFileWindow() {
      this.showWindow.bigFile = false
    },
    async fileChange() {
      if (this.$store.state.max_file_size && this.$refs.docFile.files[0].size > this.$store.state.max_file_size) {
        alert('文件大小超过限制！')
        return false
      }
      this.showWindow.bigFileOption.showProgress = true
      const fileRealName = this.$refs.docFile.files[0].name
      const uploadUrl = '/info_files/' + fileRealName
      await this.$http.put(uploadUrl, this.$refs.docFile.files[0], {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (e) => {
          this.showWindow.bigFileOption.progressValue = Math.ceil(e.loaded / e.total * 100)
        }
      }).then((data) => {
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()

        // 此处处理data
        if (this.showWindow.video) {
          this.formVideo.brief_video = data
        }
        if (this.showWindow.guide) {
          this.formGuide.tech_video = data
        }
        if (this.showWindow.courseware) {
          this.formCourseWare.src = data
          this.formCourseWare.size = this.$refs.docFile.files[0].size
        }
        if (this.showWindow.teach) {
          if (this.teachType === 1) {
            this.formTeach.teachChild[this.teachIndex].fileArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else {
            this.formTeach.expChild[this.teachIndex].fileArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          }
        }
        if (this.showWindow.promise) {
          var myDate = new Date()
          this.formPromise = {
            path: data,
            year: myDate.getFullYear(),
            month: myDate.getMonth() + 1,
            day: myDate.getDate()
          }
          this.formInfo.promise_file = this.formPromise
          this.savePromise(1)
          this.showWindow.promise = false
        }
        if (this.showWindow.materialsfile) {
          if (this.MaterialsFileType === 1) {
            this.formMaterialsFile.politicalArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else if (this.MaterialsFileType === 2) {
            this.formMaterialsFile.learnArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          } else if (this.MaterialsFileType === 3) {
            this.formMaterialsFile.outsideArry.push({
              name: this.$refs.docFile.files[0].name,
              path: data
            })
          }
        }
      }).catch((error) => {
        console.log(error)
        this.showWindow.bigFileOption.showProgress = false
        this.showWindow.bigFileOption.progressValue = 0
        this.hideFileWindow()
        this.$layer.msg('上传失败！')
      })
    },
    clearItem(categgory) {
      switch (categgory) {
        case 'introduce':
          this.formIntroduce = {
            brief: ''
          }
          this.saveIntroduce()
          break
        case 'tech_goal':
          this.formTechGoal = {
            tech_goal: ''
          }
          this.saveTechGoal()
          break
        case 'class_hour':
          this.formClassHour = {
            time_lesson: '',
            time_experiment: ''
          }
          this.saveClassHour()
          break
        case 'theory':
          this.formTheory = {
            theory_content: '',
            theory_point: ''
          }
          this.saveTheory()
          break
        case 'device':
          this.formDevice = {
            device: ''
          }
          this.saveDevice()
          break
        case 'materials':
          this.formMaterials = {
            materials: ''
          }
          this.saveMaterials()
          break
        case 'tech_func':
          this.formTechFunc = {
            tech_func: ''
          }
          this.saveTechFunc()
          break
        case 'step':
          this.formStep = {
            step_claim_des: '',
            step_claim_step: '',
            step_claim_step_des: ''
          }
          this.saveStep()
          break
        case 'result':
          this.formResult = {
            result_claim_record: 0,
            result_claim_type_ck1: false,
            result_claim_type_ck2: false,
            result_claim_type_ck3: false,
            result_claim_type_ck3_text: '',
            result_claim_content: ''
          }
          this.saveResult()
          break
        case 'check_claim':
          this.formCheckClaim = {
            check_claim: ''
          }
          this.saveCheckClaim()
          break
        case 'student':
          this.formStudent = {
            student_claim_subject: '',
            student_claim_content: ''
          }
          this.saveStudent()
          break
        case 'proj':
          this.formProj = {
            proj_situation_online_time: '',
            proj_situation_open_time: '',
            proj_situation_student_count: '',
            proj_situation_social: 0
          }
          this.saveProj()
          break
        case 'teach':
          // this.formProj = {
          //   proj_situation_online_time: '',
          //   proj_situation_open_time: '',
          //   proj_situation_student_count: '',
          //   proj_situation_social: 0
          // }
          this.saveTeach(0)
          break
        case 'net':
          this.formNet = {
            net_claim_content: '',
            net_claim_count: ''
          }
          this.saveNet()
          break
        case 'sys':
          this.formSys = {
            sys_claim_computer: '',
            sys_claim_other: '',
            sys_claim_mobile: 0
          }
          this.saveSys()
          break
        case 'not_sys':
          this.formNotSys = {
            not_sys_claim_plugin: 0,
            not_sys_claim_plugin_name: '',
            not_sys_claim_plugin_size: '',
            not_sys_claim_plugin_link: '',
            not_sys_claim_content: ''
          }
          this.saveNotSys()
          break
        case 'hard':
          this.formHard = {
            user_hardware_claim_computer: '',
            user_hardware_claim_other: ''
          }
          this.saveHard()
          break
        case 'spec':
          this.formSpec = {
            user_special_claim_hardware: '',
            user_special_claim_other: ''
          }
          this.saveSpec()
          break
        case 'net_safe':
          this.formNetSafe = {
            net_safe_claim: ''
          }
          this.saveNetSafe()
          break
        case 'frame':
          this.formFrame = {
            frame_content: '',
            frame_file: ''
          }
          this.saveFrame()
          break
        case 'experiment_tech':
          this.formExperimentTech = {
            experiment_tech_dev: '',
            experiment_tech_tool: '',
            experiment_tech_level: ''
          }
          this.saveExperimentTech()
          break
        case 'platform':
          this.formPlatform = {
            platform_lang: '',
            platform_tool: '',
            platform_db: ''
          }
          this.savePlatform()
          break
        case 'service':
          this.formService = {
            buildArry: [],
            buildDescribe: '',
            planArry: [],
            planDescribe: ''
          }
          this.saveService(0)
          break
        case 'feature':
          this.formFeature = {
            feature_design: '',
            feature_tech: '',
            feature_appraise: '',
            feature_more: ''
          }
          this.saveFeature()
          break
        case 'intel':
          this.formIntel = {
            intellectual_register: '',
            intellectual_name: '',
            intellectual_same: '',
            intellectual_username: '',
            intellectual_power: '',
            intellectual_no: ''
          }
          this.saveIntel()
          break
        case 'materialsFile':
          this.saveMaterialsfile(0)
          break
      }
    }
  },
  async mounted() {
    await this.getInfo()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
</style>
